import TogetherTierRebrand from '@/assets/image/free-to-pay/together-tier-svg/together-tier-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const TogetherTierSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'together tier', ...rest } = props;

  return <Image src={TogetherTierRebrand} alt={alt} {...rest} />;
};
